import React from 'react';

const US_STATES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY',
    'LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
    'OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC',
];

export interface AddressData {
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: string;
}

interface AddressFormProps {
    value: AddressData;
    onChange: (value: AddressData) => void;
    label?: string;
}

const AddressForm: React.FC<AddressFormProps> = ({value, onChange, label}) => {
    const update = (field: keyof AddressData, v: string) => onChange({...value, [field]: v});

    return (
        <div>
            {label && <h3 className="text-sm font-semibold text-mld-text-primary mb-3">{label}</h3>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <label className="block sm:col-span-2">
                    <span className="block text-sm text-mld-muted-text mb-1">Street Address 1</span>
                    <input
                        type="text"
                        required
                        value={value.line1}
                        onChange={(e) => update('line1', e.target.value)}
                        placeholder="Street Address 1"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-mld-success/50"
                    />
                </label>
                <label className="block sm:col-span-2">
                    <span className="block text-sm text-mld-muted-text mb-1">Street Address 2</span>
                    <input
                        type="text"
                        value={value.line2}
                        onChange={(e) => update('line2', e.target.value)}
                        placeholder="Street Address 2"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-mld-success/50"
                    />
                </label>
                <label className="block">
                    <span className="block text-sm text-mld-muted-text mb-1">City</span>
                    <input
                        type="text"
                        required
                        value={value.city}
                        onChange={(e) => update('city', e.target.value)}
                        placeholder="City"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-mld-success/50"
                    />
                </label>
                <label className="block">
                    <span className="block text-sm text-mld-muted-text mb-1">State</span>
                    <select
                        required
                        value={value.state}
                        onChange={(e) => update('state', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-mld-menu-background focus:outline-none focus:ring-2 focus:ring-mld-success/50">
                        <option value="">Select state</option>
                        {US_STATES.map((s) => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </label>
                <label className="block">
                    <span className="block text-sm text-mld-muted-text mb-1">ZIP Code</span>
                    <input
                        type="text"
                        required
                        value={value.zip}
                        onChange={(e) => update('zip', e.target.value)}
                        placeholder="ZIP Code"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-mld-success/50"
                    />
                </label>
            </div>
        </div>
    );
};

export default AddressForm;
